(function () {
  'use strict';

  angular
    .module('ringbaPortal')
    .filter('utcToLocal', utcToLocal);

  function utcToLocal(
    $filter,
    moment
  ) {
    'ngInject';

    const minDate = moment.utc('0001-01-01');

    return function (utcDateString, format) {
      if (!utcDateString) {
        return '';
      }
      
      const localTime = moment.utc(utcDateString);

      if (!localTime.isAfter(minDate)) {
        return '';
      }

      const localDate = localTime.local().toDate();
      
      // convert and format date using the built in angularjs date filter
      return $filter('date')(localDate, format);
    };

  }
})();
